const config = {
  port: process.env.PORT || 3000,
  isProduction: process.env.NODE_ENV === "production",
  apiUrl: process.env.API_URL || "",
  casUrl: process.env.CAS_URL || "",
  uaaUrl: process.env.UAA_URL || "",
  documentsUrl: process.env.DOCUMENTS_URL || "",
  clientUrl: process.env.CLIENT_URL || "",
  onlyOfficeUrl: process.env.ONLYOFFICE_URL || "",
  messagingUrl: process.env.MESSAGING_URL || "",
  aiAssistantUrl: process.env.AI_ASSISTANT_URL || "",
  messagingSecret:
    process.env.MESSAGING_SECRET || "eb2ff348-0acf-4a90-9044-9c13c5b2ddfb",
  casClientId: process.env.CAS_CLIENT_ID || "",
};

export { config };
